import { View, Modal, StyleSheet, ActivityIndicator } from 'react-native';
import React from 'react';
import { s, v } from '../../utils/libs';

const Indicator = ({ isloading }: { isloading: boolean }) => {
  return (
    <Modal
      animationType="fade"
      visible={isloading}
      transparent={true}
      hardwareAccelerated={true}>
      <View style={styles.centeredView}>
        <View style={styles.modalView}>
          <View>
            <ActivityIndicator size="large" color="#1560bd" />
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default Indicator;
const styles = StyleSheet.create({
  centeredView: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: v(22),
  },
  modalView: {
    margin: s(20),
    backgroundColor: 'white',
    borderRadius: s(20),
    padding: s(35),
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: v(2),
    },
    shadowOpacity: 0.25,
    shadowRadius: s(4),
    elevation: 5,
  },
});
